enum AccountType { PlateAccount, CustomerAccount, PlateSubAccount, CustomerSubAccount }
export default AccountType;
